import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './services/services';
import 'rxjs/add/operator/publishReplay';
@Injectable()
export class AppService {
  public _siteinfo;
    constructor(
      private http: Http,
      
      private shareService: ShareService) {  
  
    }    
	getMenu() {
	     // 'Content-Type': 'application/json', 
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');
	    ///alert(this.getToken());
	     
	   let options= new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/menu';	    
	   	if (!this._siteinfo) {  
        this._siteinfo= this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  
       }
        return this._siteinfo;
	}
	
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Server error api app.service');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/app.service.ts